import { Link } from '@tanstack/react-router';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { ErrorScreen } from '../ErrorScreen';
export function NotFound() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'component.NotFound'
  });
  return <ErrorScreen title={t('title')} description={t('description')}>
      <Link to="/">{t('backToHome')}</Link>
    </ErrorScreen>;
}